/**
 * Ensures that only numbers can be typed in an input
 *
 * @type {{bind(*): void}}
 */
export const NumberOnly = {
    bind (el) {
        el.addEventListener('keypress', (e) => {
            if (e.key.length === 1 && isNaN(e.key) && !e.ctrlKey) {
                e.preventDefault();
            }
        })
    }
};



// WEBPACK FOOTER //
// ./src/directives/input-directives.js